module.exports = __webpack_public_path__ + "img/cine-documental-y-storytelling_poster.96fd2d71.jpg";